import { BetRecordAttrs } from "@locent/types";

import { BaseComponent } from "../base/baseComponent";
import { CompType } from "../base/baseEnum";

/** 投注游戏组件类 */
export class BetRecordComponent extends BaseComponent<
  BetRecordAttrs & {
    [key: string]: string | number | boolean | object | null | undefined;
  }
> {
  constructor(
    data: Partial<
      BaseComponent<
        BetRecordAttrs & {
          [key: string]: string | number | boolean | object | null | undefined;
        }
      >
    > = {},
  ) {
    super(data);
    this.type = CompType.bet_record;
  }

  /** 获取标题图标 */
  // public getTitleIcon(): string {
  //   return this.attrs.title_icon;
  // }

  /** 设置标题图标 */
  public setTitleIcon(icon: string): void {
    this.setAttrs({ title_icon: icon });
  }

  /** 获取标题文本 */
  // public getTitleText(): string {
  //   return this.attrs.title_text;
  // }

  // /** 设置标题文本 */
  // public setTitleText(text: string): void {
  //   this.setAttrs({ title_text: text });
  // }

  // /** 获取指定语言的标题 */
  // public getTitleByLang(lang: string): string {
  //   return this.attrs.title_text || "";
  // }

  // /** 获取标题类型 */
  // public getTitleType(): number {
  //   return this.attrs.title_type;
  // }

  /** 设置标题类型 */
  // public setTitleType(type: number): void {
  //   this.setAttrs({ title_type: type });
  // }

  /** 获取配置的显示选项 */
  public getList(): string[] {
    return this.lang_attrs.list;
  }
}
